<div class="notifications-panel">
  <div class="notifications-header">
    <h2>Notifications</h2>
    <div class="tabs">
      <div class="tab-group">
        <button [class.active]="activeTab() === 'whats-new'" (click)="setActiveTab('whats-new')">
          What's New
          <span class="badge" *ngIf="unreadCount()">
            {{ unreadCount() }}
          </span>
        </button>
        <button [class.active]="activeTab() === 'previous'" (click)="setActiveTab('previous')">
          Previous
        </button>
      </div>
      <button class="clear-all" (click)="clearAll()">Clear all</button>
    </div>
    <!-- Test button for development -->
    <!-- <button class="test-notification-btn" (click)="testAddNotification()">
      <i class="fas fa-plus"></i> Test Notification
    </button> -->
  </div>

  <div class="notifications-list">
    <!-- Loading state -->
    <div class="loading-state" *ngIf="isLoading()">
      <div class="loading-content">
        <app-spinner [size]="40"></app-spinner>
      </div>
    </div>

    <!-- Empty state message -->
    <div class="empty-state" *ngIf="!isLoading() && notifications().length === 0">
      <div class="empty-icon">
        <i class="fas fa-bell-slash"></i>
      </div>
      <h3 class="empty-title">
        {{ activeTab() === 'whats-new' ? 'No new notifications' : 'No previous notifications' }}
      </h3>
      <p class="empty-description">
        {{ activeTab() === 'whats-new'
        ? 'You\'re all caught up! New notifications will appear here.'
        : 'Previously read notifications will appear here.' }}
      </p>
    </div>

    <!-- Notification items -->
    <ng-container *ngIf="!isLoading()">
      <div *ngFor="let notification of notifications(); let i = index" class="notification-item"
        [class.unread]="!notification.isRead" [class.read]="notification.isRead" [class.pinned]="notification.isPinned">
        <div class="notification-content-top">
          <div [ngClass]="getAvatarClasses(i, !!notification.user.avatar && !imageLoadError[i])">
            <ng-container *ngIf="notification.user.avatar && !imageLoadError[i]; else initialsAvatar">
              <img [src]="notification.user.avatar" [alt]="notification.user.name" (error)="onImageError(i)"
                (load)="onImageLoad(i)">
            </ng-container>
            <ng-template #initialsAvatar>
              <span class="avatar-initials">{{ getInitials(notification.user.name) }}</span>
            </ng-template>
          </div>
          <div class="notification-header">
            <span class="user-name">{{ notification.user.name }}</span>
            <div class="actions">
              <!-- Show check icon for unread, double-tick for read -->
              <button class="action-btn" (click)="markAsRead(notification); $event.stopPropagation()"
                *ngIf="!notification.isRead" title="Mark as read">
                <i class="wl_icon_single-tick"></i>
              </button>
              <button class="action-btn read-indicator" *ngIf="notification.isRead" title="Read">
                <i class="wl_icon_double-tick"></i>
              </button>
              <!-- <button class="action-btn" (click)="togglePin(notification); $event.stopPropagation()"
                [class.pinned]="notification.isPinned" title="Toggle pin">
                <i class="wl_icon_pin"></i>
              </button> -->
            </div>
          </div>
        </div>
        <div class="notification-content">
          <h3 class="notification-title">{{ notification.title }}</h3>
          <div class="project-name" *ngIf="getDisplayName(notification)"
            (click)="onNotificationClick(notification, $event)">{{ getDisplayName(notification) }}</div>
          <p class="notification-description" [innerHTML]="notification.description"></p>
          <div class="notification-meta">
            <span class="timestamp" *ngIf="notification.timestamp && notification.timestamp.trim()">
              <span class="date-label">{{ getDateLabel(notification.timestamp) }}</span>
              <span class="time-value">{{ getTimeValue(notification.timestamp) }}</span>
            </span>
            <!-- <span class="due-date">
              <span class="date-prefix">Due on </span>
              <span class="date-value">{{ notification.dueDate }}</span>
            </span> -->
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>